import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../base/button';

const ExternalButton = ({ slice }) => {
    const tag = slice.button_url._meta.tags[0]; //TAG MUST BE THE SAME AS ARCHIVE TAG
    const uid = slice.button_url._meta.uid;
    const link = tag === uid || typeof tag === 'undefined' ? `/${uid}` : `/${tag}/${uid}`;

    return (
        <SButton>
            <Button to={link}>{slice.button_label}</Button>
        </SButton>
    );
};

const SButton = styled.div`
    * + &,
    & + * {
        margin-top: 20px;
    }
`;

export default ExternalButton;

ExternalButton.propTypes = {
    slice: PropTypes.object.isRequired
};
